import { isDebugEnabled } from "shared/util-runtime-config";
import { VimeoPlayer } from "./player-implementation/pcp-vimeo-player";
import { ReactivePlayer } from "./reactive-player";
import { VideoPlayerComponent } from "./video-player.component";

export class VideoDebugLogger {

    static get enabled(): boolean {
        return isDebugEnabled();
    }

    readonly log: (...args: any[]) => void;
    readonly debug: (...args: any[]) => void;
    readonly warn: (...args: any[]) => void;
    readonly error: (...args: any[]) => void;

    private readonly logPrefix: string;


    constructor(
        private readonly context: VideoPlayerComponent | ReactivePlayer | VimeoPlayer,
    ) {
        if (VideoDebugLogger.enabled) {
            this.log = this.logToConsole;
            this.debug = this.logDebug;
            this.warn = this.logWarn;
        } else {
            this.log = this.logToVoid;
            this.debug = this.logToVoid;
            this.warn = this.logToVoid;
        }

        this.error = this.logError;
        this.logPrefix = `[VideoDebug] [${this.context.constructor.name}]`;
    }


    private readonly createConsoleLogger = (logger: typeof console.log) => (...args: any[]) => logger(this.logPrefix, ...args);

    // eslint-disable-next-line no-console
    private readonly logToConsole = this.createConsoleLogger(console.log);

    // eslint-disable-next-line no-console
    private readonly logDebug = this.createConsoleLogger(console.debug);
    private readonly logWarn = this.createConsoleLogger(console.warn);
    private readonly logError = this.createConsoleLogger(console.error);

    private readonly logToVoid = () => {
        // noop
    };
}
